.Main {
  position: fixed;
  padding: var(--space-s);
  line-height: 1;
  top: 0;
  right: 0;
  display: grid;
  gap: 0 1em;
  grid-auto-flow: column;
  grid-template-columns: repeat(3, max-content);
  grid-template-rows: repeat(2, minmax(0, 1fr));
  writing-mode: vertical-rl;
}

.Item {
  display: flex;

  span {
    display: block;
  }
}

.Inner {
  overflow: hidden;
}

.Secondary {
  background-color: var(--white);
  color: var(--grey);
  border-radius: 2em;
  padding: 0.5em 0.125em;

  &:before {
    content: '↖';
  }
}

@media (min-width: 769px) {
  .Collapsed {
    gap: 0 0.5em;

    .Inner {
      display: none;
    }

    .Secondary:before {
      display: none;
    }
  }
}
